import clsx from "clsx";
import { formatDateTime, formatRelativeTime } from "../utils/format-time";

type Props = {
  value: string | null | undefined;
  className?: string;
  fallback?: string;
};

export default function TimeAgo({ value, className, fallback = "Never" }: Props) {
  if (!value) {
    return <span className={className}>{fallback}</span>;
  }

  const exact = formatDateTime(value);

  return (
    <time
      dateTime={value}
      title={exact}
      className={clsx("whitespace-nowrap tabular-nums", className)}
    >
      {formatRelativeTime(value)}
    </time>
  );
}
